import React from 'react';
import { Link } from 'react-router-dom';
import './Experience.css';
import TMR from '../Assets/TMR_image.jpg';
import hyperloop from '../Assets/Hyperloop.jpg';
import Momentum from '../Assets/Momentum.jpg';
import Echolabs from '../Assets/Echolab.png';
import TMU from '../Assets/TMU.jpg';


const Experience = () => {
    const experiences = [
        {
            id: 1,
            company: 'Toronto Metropolitan University',
            role: 'Research Practicum Assistant',
            period: '05/2024 - 05/2025',
            image: TMU,
            bullets: [
                'Analyzed 13+ Canadian university curricula and 3 international research papers, producing a benchmark report that informed a redesign of the Linear Algebra course used by 1,000+ first-year students.',
                'Collaborated with a multidisciplinary team to architect a complete instructional plan including learning outcomes, structured modules, and evaluation rubrics.',
                'Co-developing a PreText-based open-source textbook, translating pre-calculus concepts into university-level linear algebra with scalable digital publishing workflows.'
            ]
        },
        {
            id: 2,
            company: 'Toronto Met Robotics',
            role: 'Robotics Software Developer',
            period: '10/2024 - Present',
            image: TMR,
            bullets: [
                'Engineered a real-time robotic rover control system enabling concurrent actuator management with gamepad input using Python, Pysocket, WebSocket, and multithreaded event loops.',
                'Built a multi-camera rover GUI using PyGST and TCP-based streaming, improving debugging and operator visibility during autonomous navigation tests.',
                'Designed dual video-processing pipelines (high-fps vs. low-latency modes), improving streaming stability and reducing data transmission delays during field tests.'
            ]
        },
        {
            id: 3,
            company: 'Momentum AI',
            role: 'Full Stack Developer',
            period: '05/2025 - Present',
            image: Momentum,
            bullets: [
                'Developed core backend services for an AI-driven study platform featuring agentic flashcard generation, exam creation, and RAG-powered studying assistance using Flask, Python, PostgreSQL, and Supabase Vector DBs.',
                'Built and optimized REST APIs and orchestration flows handling thousands of content-generation requests, integrating embeddings, retrieval pipelines, and rate-limited LLM tools.',
                'Led deployments, version control, and feature branching using Git, while mentoring students in hackathons and university workshops.'
            ]
        },
        {
            id: 4,
            company: 'Echolabs (Affiliated with PM Accelerator)',
            role: 'Lead Engineer and Full Stack Engineer',
            period: '06/2025 - Present',
            image: Echolabs,
            bullets: [
                'Directed a 7-engineer cross-functional team, delivering a full MVP in under 6 weeks and winning 3rd place out of the accelerator cohort, while working closely with project managers and designers to complete a startup.',
                'Architected an automated B2B ticket-intelligence platform using agentic classification, similarity clustering, RAG hypothesis generation, and multi-platform integrations. Managed team with version control tools such as Git with strong API integration.',
                'Integrated FastAPI, Node.js, PostgreSQL, Supabase Vector DBs, and HuggingFace models, deploying production-grade pipelines with CI/CD and automated testing using ML libraries such as Pandas, Tensorflow, and Scikit-learn.',
                'Led code reviews, sprint planning, and system design sessions focused on reliability, modularity, and throughput optimization.'
            ]
        },
        {
            id: 5,
            company: 'Metropolitan Hyperloop',
            role: 'Network Programming Controls Lead',
            period: '09/2024 - Present',
            image: hyperloop,
            bullets: [
                'Developed a high-performance GUI with PySide6 to visualize real-time pod telemetry using successful C++ and Python multithreaded TCP socket communication in a Linux environment.',
                'Implemented a Raspberry Pi–based sensor acquisition system, integrating low-level hardware drivers with C++/Python networking scripts, establishing communication with 4 traversory sensors system, LIM control, circuits, batteries and breaks.',
                'Utilized sensor connection with a RaspberryPi for data acquisition, processing, and communication with the central GUI.',
            ]
        }
        // Add more experiences here
    ];

    return (
        <div className='w-full py-12 px-4 bg-gradient-to-b from-transparent to-black/30'>
            <div className='max-w-7xl mx-auto'>
                <div className='text-center mb-8'>
                    <h2 className='text-3xl md:text-4xl font-bold text-white mb-2'>
                        My <span className='text-[#00d59a]'>Experience</span>
                    </h2>
                    <p className='text-gray-400 text-sm md:text-base'>
                        Professional roles and achievements
                    </p>
                </div>
                <div className='experience-container'>
                    <div className='experience-grid'>
                            {experiences.map((exp, index) => (
                                <div key={exp.id} className={`experience-card ${index % 2 === 1 ? 'reverse' : ''}`}>
                                <div className='exp-image-container'>
                                    <img src={exp.image} alt={exp.company} className='exp-image' />
                                </div>
                                <div className='exp-content'>
                                    <div className='exp-header'>
                                        <h3 className='exp-company'>{exp.company}</h3>
                                        <p className='exp-period'>{exp.period}</p>
                                    </div>
                                    <p className='exp-role'>{exp.role}</p>
                                    <ul className='exp-bullets'>
                                        {exp.bullets.map((bullet, idx) => (
                                            <li key={idx}>{bullet}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Experience;
